import { Expose, plainToClassFromExist, Type } from 'class-transformer';

import { SnDVRStream } from './dvr-stream';
import { SnStreamSourceList } from './stream-source-list';

export class SnDVRSource {
  @Expose()
  @Type(() => SnDVRStream)
  public cloud: SnDVRStream;

  @Expose()
  @Type(() => SnDVRStream)
  public local: SnDVRStream;

  constructor(data: any = {}) {
    plainToClassFromExist(this, data, { strategy: 'excludeAll' });
  }

  public toStreamSourceList(timeshift?: number, start?: Date, end?: Date): SnStreamSourceList {
    return new SnStreamSourceList({
      cloud: this.cloud?.toStreamSources(timeshift, start, end),
      local: this.local?.toStreamSources(timeshift, start, end),
    });
  }

  public toStreamSourceListFmp4(timeshift?: number, start?: Date, end?: Date): SnStreamSourceList {
    return new SnStreamSourceList({
      cloud: this.cloud?.toStreamSourcesFmp4(timeshift, start, end),
      local: this.local?.toStreamSourcesFmp4(timeshift, start, end),
    });
  }

  public toFususStreamSourceList(path: string, start: Date): SnStreamSourceList {
    return new SnStreamSourceList({
      cloud: this.cloud?.toFususStreamSources(path, start),
      local: this.local?.toFususStreamSources(path, start),
    });
  }

  public toAvigilonStreamSourceList(start: Date): SnStreamSourceList {
    return new SnStreamSourceList({
      cloud: this.cloud.toAvigilonStreamSources(start),
      local: this.local.toAvigilonStreamSources(start),
    });
  }

  public toFederalStreamSourceList(start: Date, end: Date): SnStreamSourceList {
    return new SnStreamSourceList({
      cloud: this.cloud?.toFederalStreamSources(start, end),
      local: this.local?.toFederalStreamSources(start, end),
    });
  }
}

export class SnDVRSources {
  @Expose()
  @Type(() => SnDVRSource)
  public main: SnDVRSource;

  @Expose()
  @Type(() => SnDVRSource)
  public sub: SnDVRSource;
}
